/** Idoing / OpenGate 品牌资源 */
export const BRAND_NAME = 'Idoing'
export const BRAND_LOGO_URL =
  'https://plusyifanshang.oss-cn-hangzhou.aliyuncs.com/box/img/other/2ndgUDQ5HlwKw591eaNlqmENgjRa2x9yYMyr8kcz.png'
